<template>
  <div v-if="flashError" class="alert alert-danger alert-dismissible fade show" role="alert">
    {{ flashError }}
    <button type="button" class="btn-close" @click="flashError = null" :aria-label="'backend.actions.close'"></button>
  </div>

  <div class="hstack gap-2">
    <h3>{{ title }}</h3>
    <div class="ms-auto d-flex gap-2">
      <AsyncButton
        v-if="canRetry && resultOrchestratorUrl"
        class="btn btn-link btn-sm text-muted text-decoration-none"
        @click="retry"
      >
        <AVIcon icon="redo" />
        {{ t("backend.e2e.voting_round_reports.show.retry") }}
      </AsyncButton>
      <AsyncButton
        v-if="canReset && resultOrchestratorUrl"
        class="btn btn-link btn-sm text-muted text-decoration-none"
        @click="reset"
      >
        <AVIcon icon="sync-alt" />
        {{ t("backend.e2e.voting_round_reports.show.reset") }}
      </AsyncButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import AsyncButton from "@/components/shared/AsyncButton.vue";
import apiClient from "@/entrypoints/frontend/apiClient";
import { useI18n } from "vue-i18n";
import { computed, ref } from 'vue';

const { t } = useI18n();

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  orchestratorId: {
    type: Number,
    required: true,
  },
  canRetry: {
    type: Boolean,
    default: false,
  },
  canReset: {
    type: Boolean,
    default: false,
  },
});

const flashError = ref<string | null>(null);

const resultOrchestratorUrl = computed(() => {
  const baseUrl = new URL(window.location.href);
  const regex = /\/backend\/organisations\/(?<organisationId>\d+)\/elections\/(?<electionId>\d+)/;
  const match = baseUrl.pathname.match(regex);

  if (match) {
    const { organisationId, electionId } = match.groups;
    baseUrl.pathname = `/backend/organisations/${organisationId}/elections/${electionId}/e2e/result_orchestrators/${props.orchestratorId}`;

    return baseUrl;
  }

  return null;
});

const retry = async () => {
  if (!confirm(t("backend.e2e.voting_round_reports.show.confirm_retry"))) return;
  const url = `${resultOrchestratorUrl.value}/retry`;

  try {
    await apiClient.post(url);
  } catch {
    flashError.value = t("backend.e2e.voting_round_reports.show.retry_failed");
  }
};

const reset = async () => {
  if (!confirm(t("backend.e2e.voting_round_reports.show.confirm_reset"))) return;
  const url = `${resultOrchestratorUrl.value}/reset`;

  try {
    await apiClient.post(url);
  } catch {
    flashError.value = t("backend.e2e.voting_round_reports.show.reset_failed");
  }
};
</script>
